import { render, staticRenderFns } from "./CampusOverview.vue?vue&type=template&id=4973bcd7&scoped=true&xmlns%3A=true"
import script from "./CampusOverview.vue?vue&type=script&lang=js"
export * from "./CampusOverview.vue?vue&type=script&lang=js"
import style0 from "./CampusOverview.vue?vue&type=style&index=0&id=4973bcd7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973bcd7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4973bcd7')) {
      api.createRecord('4973bcd7', component.options)
    } else {
      api.reload('4973bcd7', component.options)
    }
    module.hot.accept("./CampusOverview.vue?vue&type=template&id=4973bcd7&scoped=true&xmlns%3A=true", function () {
      api.rerender('4973bcd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/components/campusPreview/CampusOverview.vue"
export default component.exports